
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1779.961a9.961 9.961 0 109.961 9.961 9.961 9.961 0 00-9.961-9.961zm1.713 15.1a.7.7 0 01-.153.143 4.8 4.8 0 01-2.741.894 1.139 1.139 0 01-1.2-1.5c.251-1.052.512-2.1.767-3.15a.755.755 0 00-.014-.578.639.639 0 00-.333-.271 1.269 1.269 0 00-.23-.038c-.1-.022-.237-.038-.307-.143l-.022-.034a.325.325 0 01.094-.458l.181-.12.269-.149a4.456 4.456 0 01.494-.221 5.749 5.749 0 011.068-.307 5.07 5.07 0 01.667-.074 2.438 2.438 0 01.538.058 1.094 1.094 0 01.8 1.432c-.249 1.06-.514 2.116-.773 3.166-.124.5 0 .721.506.857.076.02.153.034.231.052.258.063.32.227.158.441zm-.851-7.913a1.7 1.7 0 111.71-1.687 1.7 1.7 0 01-1.709 1.686z"}})])])
          )
        }
      }
    